import React from 'react';
import Button from '../ui/Button';
import { ClockIcon, ShoppingCartIcon } from 'lucide-react';
const FinalCta = () => {
  return <section className="bg-indigo-900 text-white py-16 md:py-24" data-id="element-154">
      <div className="container mx-auto px-4 text-center" data-id="element-155">
        <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-156">
          Ready to Transform Your Sleep and Performance?
        </h2>
        <p className="text-xl max-w-3xl mx-auto mb-10" data-id="element-157">
          Join the executives across Europe who've discovered that better sleep
          is the ultimate competitive advantage in today's high-pressure
          business environment.
        </p>
        <div className="max-w-md mx-auto bg-indigo-800 p-8 rounded-lg mb-10" data-id="element-158">
          <div className="flex items-center justify-center mb-6" data-id="element-159">
            <ClockIcon className="w-6 h-6 mr-2" data-id="element-160" />
            <p className="font-semibold text-lg" data-id="element-161">
              Limited Time Offer: Save €70
            </p>
          </div>
          <p className="mb-6 text-lg" data-id="element-162">
            The Executive Performance Package is available at a special
            introductory price for a limited time.
          </p>
          <div className="flex justify-center items-center mb-3" data-id="element-163">
            <p className="text-gray-300 line-through text-xl mr-4" data-id="element-164">€209</p>
            <p className="text-4xl font-bold" data-id="element-165">€139</p>
          </div>
          <p className="text-indigo-200 mb-6" data-id="element-166">
            90-night supply with Satisfaction Guarantee
          </p>
          <a href="https://get.myhealthbeam.com/mptestcheck" className="block" data-id="element-167">
            <Button primary={true} className="w-full py-5 text-xl bg-indigo-600 hover:bg-indigo-700 text-white font-bold tracking-wide uppercase flex items-center justify-center shadow-lg border-2 border-indigo-500" data-id="element-168">
              <ShoppingCartIcon className="w-5 h-5 mr-2" data-id="element-169" />
              Order Now
            </Button>
          </a>
        </div>
        <p className="text-indigo-200" data-id="element-170">
          * Free shipping on all EU orders. International shipping available at
          checkout.
        </p>
      </div>
    </section>;
};
export default FinalCta;